import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DatepickerHelper } from '../../../shared/validators/date-picker-form-validators';
import { AsicBankData } from '@models/ui-models/asic-bank-data';
import { Company } from '@models/companies/company';
import { Document } from '@models/documents/document';
import { EntityChangeData } from '@models/documents/entity-change-data';
import { CompanyChangeData } from '@models/ui-models/company-change-data';
import { IndividualData } from '@models/individuals/individual-data';
import { ChangeDictionaryHelper } from '@models/ui-models/change-dictionary-helper.model';
import { AsicFormRa04Component } from '../../asic-forms/company/asic-form-ra04/asic-form-ra04.component';

export enum Ra04DirectDebitRequestStepsEnum {
  FormDescription = 0,
  Customer = 1,
  DetailsOfTheAccountToBeDebited = 2,
}

export class AsicFormRA04 extends EntityChangeData {
  static override readonly $type = 'AsicFormRA04';

  date: Date;
  companyName: string | null;
  companyAcn: string | null;
  individual: IndividualData | null;
  bankData: AsicBankData;
  ecrForm: boolean;
  otherForms: boolean;

  constructor(data: Partial<AsicFormRA04> = {}) {
    super(data);

    // TODO: Add ChangeType
    this.date = data.date ?? new Date();
    this.companyName = data.companyName ?? null;
    this.companyAcn = data.companyAcn ?? null;
    this.individual = data.individual ?? null;
    this.bankData = data.bankData ?? new AsicBankData();
    this.ecrForm = data.ecrForm ?? false;
    this.otherForms = data.otherForms ?? false;
  }

  override toDictionary(): { key: string; value: string; }[] {
    const dict = new ChangeDictionaryHelper();

    dict
      .add('Name and branch of financial institution', this.bankData.bankName)
      .add('BSB Number', this.bankData.bankBSB)
      .add('Account Number', this.bankData.bankAccountNumber)
      .add('Account Name', this.bankData.bankAccountName)
      .add('Daily ASIC Credit Limit', this.bankData.dailyCreditLimit)
      .add('Agent Type', this.individual ? 'Individual' : 'Company');

    if (this.individual) {
      dict
        .add('Name', this.individual.fullName)
        .add('Former Name', this.individual.formerName)
    } else {
      dict
        .addAcn('ACN', this.companyAcn)
        .add('Company Name', this.companyName);
    }

    return dict.dictionary;
  }

  override fillModal(modalRef: NgbModalRef, document: Document, actualCompany: Company): NgbModalRef {
    modalRef = this.fillModalWithCompany(modalRef, actualCompany, true);
    (modalRef.componentInstance as AsicFormRa04Component).companyChangeData.documentId = document.documentId;

    return modalRef;
  }

  override fillModalWithCompany(modalRef: NgbModalRef, company: Company, isEdit: boolean): NgbModalRef {
    const instance = modalRef.componentInstance as AsicFormRa04Component;

    instance.isEdit = isEdit;
    instance.formModel = structuredClone(this);
    instance.companyChangeData = new CompanyChangeData(company);

    return modalRef;
  }

  override prepareToRequest(): AsicFormRA04 {
    return {
      ...this,
      ...super.prepareToRequest(),
      date: DatepickerHelper.buildDateString(this.date),
    };
  }
}
